import { combineReducers } from 'redux';

import { detailsVisiblePrecisionReducer } from './detailsVisiblePrecision';
import { featuresReducer } from './features';
import { frecklesReducer } from './freckles';
import { infrastructureReducer } from './infrastructure';
import { isAwaitingGeoFocusReducer } from './isAwaitingGeoFocus';
import { isDrawingModeReducer } from './isDrawingMode';
import { isFirstMapInteractionReducer } from './isFirstMapInteraction';
import { isRulerEnabledReducer } from './isRulerEnabled';
import { mapBoundsReducer } from './mapBounds';
import { viewedCianIdsReducer } from './viewedCianIds';
import { TMapActions } from '../actions';
import { IMapInternalState } from '../types';
import { selectionReducer } from './selection/selection';

export {
  isFirstMapInteractionReducer,
  defaultState as isFirstMapInteractionDefaultState,
} from './isFirstMapInteraction';
export { isRulerEnabledReducer, defaultState as isRulerEnabledDefaultState } from './isRulerEnabled';
export { isDrawingModeReducer, defaultState as isDrawingModeDefaultState } from './isDrawingMode';
export { isAwaitingGeoFocusReducer, defaultState as isAwaitingGeoFocusDefaultState } from './isAwaitingGeoFocus';
export { featuresReducer, defaultState as featuresDefaultState } from './features';
export { viewedCianIdsReducer, defaultState as viewedCianIdsDefaultState } from './viewedCianIds';
export { selectionReducer, defaultState as selectionDefaultState } from './selection/selection';
export { frecklesReducer, defaultState as frecklesDefaultState } from './freckles';
export * from './infrastructure';

export const mapReducer = combineReducers<IMapInternalState, TMapActions>({
  selection: selectionReducer,
  features: featuresReducer,
  viewedCianIds: viewedCianIdsReducer,
  freckles: frecklesReducer,
  detailsVisiblePrecision: detailsVisiblePrecisionReducer,
  infrastructure: infrastructureReducer,
  isFirstMapInteraction: isFirstMapInteractionReducer,
  isDrawingMode: isDrawingModeReducer,
  isRulerEnabled: isRulerEnabledReducer,
  isAwaitingGeoFocus: isAwaitingGeoFocusReducer,
  mapBounds: mapBoundsReducer,
});
